var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockedCountries28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2c4.97 0 9 4.161 9 9.295 0 4.146-2.644 7.924-5.064 11.381-.806 1.15-1.587 2.266-2.237 3.348a1.967 1.967 0 0 1-3.398 0c-.65-1.082-1.431-2.197-2.237-3.348C7.644 19.219 5 15.441 5 11.295 5 6.16 9.03 2 14 2Zm-1.929 5.422 1.582 1.294a.549.549 0 0 0 .695 0l1.581-1.294a1.172 1.172 0 0 1 1.65 1.649l-1.295 1.582a.549.549 0 0 0 0 .694l1.294 1.582a1.172 1.172 0 0 1-1.649 1.65l-1.581-1.295a.549.549 0 0 0-.696 0l-1.581 1.294a1.172 1.172 0 0 1-1.65-1.649l1.295-1.582a.549.549 0 0 0 0-.694L10.422 9.07a1.172 1.172 0 0 1 1.649-1.65Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedCountries28);
export default __webpack_public_path__ + "static/media/blocked_countries_28.8ea2245c.svg";
export { ForwardRef as ReactComponent };